import { useState } from 'react';
import { compose, F, T, tap } from 'ramda';

import ReportsTile from '../../shared/ReportsTile';
import { selectSelectedCompany } from 'companies/companies.slice';
import { useSelector } from 'react-redux';
import { downloadInvoiceStatusReport } from 'shared/api/invoiceStatusApi';
import { useErrorNotifier } from 'shared/custom-hooks/useNotifiers';
import { CRLType } from 'shared/types/non-plan-year.types';

interface InvoiceStatusProps {
  serviceType: CRLType;
  startDate: string | null;
  endDate: string | null;
  count: number | null;
}

function InvoiceStatus({ serviceType, startDate, endDate, count }: InvoiceStatusProps) {
  const [ downloading, setDownloading ] = useState(false);
  const doneDownloading = compose(setDownloading, F);
  const startDownloading = compose(setDownloading, T);

  const errorNotifier = useErrorNotifier();
  const handleError = compose(tap(doneDownloading), errorNotifier);

  const { compid } = useSelector(selectSelectedCompany) ?? { compid: 0 };

  function handleExport() {
    startDownloading();
    downloadInvoiceStatusReport(compid, serviceType, startDate ?? undefined, endDate ?? undefined)
      .then(doneDownloading)
      .catch(handleError);
  }

  return (
    <ReportsTile
      count={count}
      title="Invoice Status"
      description="Detailed list of invoices sent within the date range selected per participant and their status."
      exportDisabled={count === null || !startDate || !endDate}
      onExport={handleExport}
      downloading={downloading}
    />
  );
}

export default InvoiceStatus;
